import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'lvr-info-tooltip',
	imports: [MatIconModule, MatTooltipModule],
	template: `
		<mat-icon
			class="info-tooltip-icon"
			[matTooltip]="text()"
			matTooltipPosition="above"
			matTooltipClass="info-tooltip"
			[attr.aria-label]="ariaLabel()"
			tabindex="0"
			fontIcon="info"
		/>
	`,
})
export class InfoTooltip {
	public readonly text = input.required<string>();
	public readonly ariaLabel = input<string>('Information');
}
